export * from "./gauntlets.svg";
export * from "./gauntlets-main.svg";
export * from "./gauntlets-off.svg";
export * from "./gauntlets-neither.svg";
export * from "./ring-main.svg";
export * from "./ring.svg";

export const z = 3;
